// extracted by mini-css-extract-plugin
export var animationContainer = "_hm-0";
export var asteriskIcon = "_hm-8";
export var conversationLeftSection = "_hm-4";
export var conversationListItem = "_hm-3";
export var conversationMiddleSection = "_hm-5";
export var conversationRightSection = "_hm-6";
export var detailsContent = "_hm-1";
export var listContainer = "_hm-7";
export var modalContent = "_hm-2";